exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table tr td[data-v-639f2ca3]{border:1px solid #808184;padding:5px}table tr td[data-v-639f2ca3]:first-child{border-left:0}table tr td[data-v-639f2ca3]:last-child{border-right:0}.checkbox[data-v-639f2ca3]{width:20px;height:20px;background:#cfcfe9;display:inline-block;vertical-align:middle;position:relative}.checked[data-v-639f2ca3]:after{position:absolute;top:0;bottom:0;left:0;right:0;content:\"\\274C\";font-size:12px;color:#fff;line-height:20px;text-align:center}.input[data-v-639f2ca3]{min-height:23px;background:#cfcfe9;padding:1px 10px}", ""]);

// exports
